<template>
  <div class="teacher-invigilation-bg">
    <exam-header :canClickLogo="true"></exam-header>

    <div class="teacher-invigilation-container">

      <!-- 查询区 -->
      <div class="invig-form-warp">
        <div class="page-title-warp">
          <!-- <div class="back" @click="goBack"><i class="el-icon-arrow-left"></i>返回</div> -->
          <div class="title"><i></i>监考回放</div>
        </div>
        <!-- 顶部统计信息 -->
        <div class="invigilation-info-card">
          <div class="card-left">
            <div v-if="headerInfo.secondView" class="secondView-tip"><span class="ic_record"></span>双视角监考</div>
            <div class="info-item">考试名称：<span class="strong">{{ headerInfo.roundName || '-' }}</span></div>
            <div class="info-item">考试id：<span class="strong">{{ roundId || '-' }}</span></div>
            <div class="info-item">考试实际参与人数：<span class="strong">{{ headerInfo.joinCount || 0 }}人</span></div>
            <div class="info-item">完成考试人数：<span class="strong">{{ headerInfo.finishCount || 0 }}人</span></div>
          </div>

          <div class="invigilation-info-tips">
            <div class="tip ok">考试正常：{{ headerInfo.normalCount || 0 }}人</div>
            <div class="tip warn">考试存疑：{{ headerInfo.cheatCount || 0 }}人</div>
          </div>
        </div>

        <div class="invig-search-bar">
          <el-form :inline="true" class="invig-form">
            <el-form-item label="用户名：">
              <el-input v-model="filters.name" placeholder="请输入" class="invig-input" clearable/>
            </el-form-item>
            <el-form-item label="用户手机号：">
              <el-input v-model="filters.phone" placeholder="请输入" class="invig-input"  clearable/>
            </el-form-item>
            <el-form-item label="监考结果：">
              <el-select v-model="filters.cheat" placeholder="请选择" class="invig-select">
                <el-option label="全部" value="" />
                <el-option label="正常" :value="false" />
                <el-option label="存疑" :value="true" />
              </el-select>
            </el-form-item>
            <el-form-item label="存疑问题：">
              <el-select v-model="filters.cheatType" placeholder="请选择" class="invig-select_cheat" multiple="" clearable>
                <!-- <el-option label="全部" value="" /> -->
                <el-option v-for="p in CheatTypeList" :key="p.value" :label="p.label" :value="p.value" />
              </el-select>
            </el-form-item>
          </el-form>
          <div class="search-btnGroup">
            <el-button type="primary" @click="handleSearch" class="search-btn btn">查询</el-button>
            <el-button @click="handleReset" class="reset-btn btn">重置</el-button>
          </div>
        </div>
      </div>

      <!-- 表格区 -->
      <div class="invig-table-warp" v-if="listLoading || (tableData && tableData.length)">
        <el-table :data="tableData" class="invig-table teacher-table" v-loading="listLoading">
          <el-table-column prop="name" label="用户名" width="100" align="center"/>
          <el-table-column prop="phone" label="用户手机号" width="120" />
          <el-table-column prop="examDurationMin" label="考试花费时间（分钟）" width="120" align="center" />
          <el-table-column prop="cheat" label="监考结果" width="120" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.cheat ? 'warning' : 'success'" class="resultTag">
                {{ scope.row.cheat ? '存疑' : '正常' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="存疑问题" min-width="260">
            <template slot-scope="scope">
              <div class="suspect-list">
                  <div class="suspect-chips" v-if="scope.row.suspectProblems && scope.row.suspectProblems[0]">
                    <span class="chip chip-title">主视角：</span>
                    <span class="chip" v-for="(s, idx) in scope.row.suspectProblems" :key="idx">{{ s.label }}（{{ s.count }}）</span>
                  </div>
                  <div class="suspect-chips" v-if="scope.row.suspectProblemsMobile && scope.row.suspectProblemsMobile[0]">
                    <span class="chip chip-title">第二视角：</span>
                    <span class="chip" v-for="(s, idx) in scope.row.suspectProblemsMobile" :key="idx">{{ s.label }}（{{ s.count }}）</span>
                  </div>
                <!-- <el-tooltip placement="top" popper-class="invig-tip" effect="dark">
                  <div slot="content">
                    <div v-for="(s, idx) in scope.row.suspectProblems" :key="idx" class="tip-line">{{ s.label }}（{{ s.count }}）</div>
                  </div>
                  <div class="suspect-chips">
                    <span class="chip" v-for="(s, idx) in scope.row.suspectProblems" :key="idx">{{ s.label }}（{{ s.count }}）</span>
                  </div>
                </el-tooltip> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="人工备注" min-width="200" show-overflow-tooltip />
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button type="text" class="teacher-paper-edit-btn" @click="handleView(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="teacher-pagination">
          <div class="pagination-info">
            共<span>{{ pagination.total }}</span>条
          </div>
          <div class="pagination-controls">
          <el-pagination
            layout="prev, pager, next, jumper"
            :total="pagination.total"
            :page-size="pagination.pageSize"
            :current-page="pagination.pageNo"
            @current-change="handlePageChange"
          />
          </div>
        </div>
      </div>
      <div class="invig-table-warp table-empty-warp" v-else>
        <empty-page text="暂无监考记录"></empty-page>
      </div>
    </div>
  </div>
</template>

<script>
import { Form, FormItem, Select, Option, Input, Button, Table, TableColumn, Pagination, Tooltip, Tag } from 'element-ui';
import ExamHeader from './components/teacherExamHeader.vue';
import EmptyPage from './components/emptyPage.vue';
import { getStudentInvigilateList, getStudentInvigilateStat } from '@/api/qzTeacher';
import parseParams from '@/common/js/util';
import { CheatTypeList } from '@/common/constant/qz';

export default {
  name: 'TeacherPaperInvigilationDetail',
  components: {
    'exam-header': ExamHeader,
    'empty-page': EmptyPage,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-select': Select,
    'el-option': Option,
    'el-input': Input,
    'el-button': Button,
    'el-table': Table,
    'el-table-column': TableColumn,
    'el-pagination': Pagination,
    'el-tooltip': Tooltip,
    'el-tag': Tag,
  },
  data() {
    return {
      roundId: this.$route.query.roundId,
      CheatTypeList,
      headerInfo: {
        roundName: '初试',
        joinCount: 0,
        finishCount: 0,
        normalCount: 0,
        cheatCount: 0,
      },
      filters: {
        name: '',
        phone: '',
        cheat: '',
        cheatType: [],
      },
      tableData: [],
      listLoading: false,
      pagination: {
        total: 0,
        pageNo: 1,
        pageSize: 20,
      },
    };
  },
  created() {
    this.getStat();
    this.getList();
  },
  methods: {
    goBack() {
      this.$router.push({
        name:'paperListTeacher'
      });
    },
    getStat() {
      getStudentInvigilateStat(this.roundId).then(res => {
        if (res.code === 200 && res?.body) {
          const {roundName, statistics = {}, secondView} = res.body.roundStatistics;

          this.headerInfo = {
            roundName: roundName || '考试名字==',
            secondView,
            joinCount: statistics.actualCount || 0,
            finishCount: statistics.finishCount || 0,
            normalCount: statistics.normalCount || 0,
            cheatCount:  statistics.doubtCount || 0,
          }
        }
      })
    },
    // 查询列表（后续替换为真实接口）
    getList(pageNo = 1) {
      this.listLoading = true;
      getStudentInvigilateList({
        roundId: this.roundId,
        page: pageNo,
        size: 20,
        ...parseParams(this.filters),
      }).then((res) => {
        if (res.code === 200 && res?.body) {
          const list = res.body.students;
          this.tableData = (list || []).map(item => {
            const cheatCounts = item.cheatCounts || {};
            const suspectProblems = Object.keys(cheatCounts).map(key => {
              const cheatType = this.CheatTypeList.find(p => p.value === key);
              return {
                value: key,
                label: cheatType ? cheatType.label : key,
                count: cheatCounts[key]
              };
            });
            const suspectProblemsMobile = Object.keys(item.cheatCountsMobile || {}).map(key => {
              const cheatType = this.CheatTypeList.find(p => p.value === key);
              return {
                value: key,
                label: cheatType ? cheatType.label : key,
                count: item.cheatCountsMobile[key]
              }
            })

            suspectProblems.sort((a, b) => b.count - a.count);
            suspectProblemsMobile.sort((a, b) => b.count - a.count);

            return {
              ...item,
              remark: item.remarks.length ? item.remarks[item.remarks.length-1].content : '',
              examDurationMin: Math.round(item.costTimeSec / 60),
              suspectProblems: suspectProblems,
              suspectProblemsMobile: suspectProblemsMobile,
            }
          });
          this.pagination = {
            ...this.pagination,
            pageNo,
            total: res.body?.total,
          }
        }
      }).finally(() => {
        this.listLoading = false;
      })
    },
    getProblemLabel(val) {
      const item = this.CheatTypeList.find(i => i.value === val);
      return item ? item.label : '';
    },
    handleSearch() {
      this.getList(1);
    },
    handleReset() {
      this.filters = {
        name: '',
        phone: '',
        cheat: '',
        cheatType: '',
      };
      this.getList(1);
    },
    handlePageChange(page) {
      this.getList(page);
    },
    handleView(row) {
      this.$router.push({
        name: 'userInvigilationDetail',
        query: {
          roomId: row.roomId,
          userId: row.id,
          startTime: row.startTimeMs,
          endTime: row.endTimeMs,
        }
      })
    },
  },
};
</script>

<style scoped lang="less">
.teacher-invigilation-bg {
  background: #EDE4DA;
  min-height: 100vh;
  padding-top: 72px;
  box-sizing: border-box;
}
.teacher-page-hd-btns {
  display: flex;
  gap: 10px;
}
.teacher-invigilation-container {
  max-width: 1400px;
  margin: 24px auto;
  padding: 0 24px 40px;
}
.invigilation-info-card {
  background: #F5F6F9;
  border-radius: 8px;
  padding: 6px 16px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  .card-left {
    display: flex;
    align-items: center;
  }
  .info-item {
    color: #4E5969;
    font-size: 14px;
    margin-right: 20px;
    .strong {
      color: #1D2129;
      font-weight: 500;
    }
  }
}
.secondView-tip {
  background: #FAEDD6;
  width: 120px;
  height: 36px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1D2129;
  font-size: 14px;
  font-weight: 500;
  margin-right: 4px;
  .ic_record {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: url('@/common/images/ic_record.png') center no-repeat;
    background-size: 12px 12px;
    background-color: #BD9F68;
    margin-right: 4px;
  }
}
.invigilation-info-tips {
  display: flex;
  gap: 16px;
  align-items: center;
  .tip {
    display: inline-flex;
    align-items: center;
    height: 36px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 4px;
    padding: 7px 16px;
    font-size: 14px;
    color: #000000E5;
    font-weight: 500;
    &.ok {
      background: #E8F7E8;
    }
    &.ok::before {
      content: '';
      width: 16px;
      height: 16px;
      margin-right: 4px;
      background: url('@/common/images/ic_correct2.png') center / contain no-repeat;
    }
    &.warn {
      background: #FAEBEB;
    }
    &.warn::before {
      content: '';
      width: 16px;
      height: 16px;
      margin-right: 4px;
      background: url('@/common/images/ic_warning.png') center / contain no-repeat;
    }
  }
}
.invig-form-warp {
  background: #fff;
  padding: 36px 40px;
  border-radius: 12px 12px 0 0;
  margin-top: 16px;
  .page-title-warp {
    position: relative;
    text-align: center;
    width: 100%;
    font-weight: 600;
    margin-bottom: 20px;

    .back {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      font-size: 16px;
      color: #4E5969;
      cursor: pointer;

      i {
        color: #4E5969;
        margin-right: 8px;
      }
    }

    .title {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      font-weight: 600;
      color: #000000;

      i {
        width: 24px;
        height: 24px;
        background: url("@/common/images/ic_title_record.png") no-repeat center center;
        background-size: cover;
        margin-right: 6px;
      }
    }
  }
}
.invig-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .center {
    display: flex;
    align-items: center;
    font-size: 24px;
    color: #243342;
  }
}
.search-btnGroup {
  display: flex;
  align-items: center;
  padding-top: 2px;
  .btn {
    width: 92px;
    height: 36px;
    border-radius: 90px;
    font-size: 14px;
    border: none;
  }
  .search-btn {
    color: #FFFFFF;
    background: #E60012;
    margin-right: 16px;
  }
  .reset-btn {
    color: #000000;
    background: #F2F3F5;
  }
}
.invig-search-bar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.invig-form {
  flex: 1;
  display: flex;
  // align-items: center;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 16px;
  /deep/ .el-form-item__label {
    font-size: 16px;
    font-weight: bold;
    padding: 0 4px 0 0;
    color: #1D2129;
  }
  /deep/ .el-form-item {
    margin-bottom: 0;
    margin-right: 0;
  }
}
.invig-select { width: 120px; }
.invig-select_cheat { width: 200px;}
.invig-input { width: 120px; }

.invig-table-warp {
  padding: 24px;
  background: #F7F6F5;
  border-radius: 0 0 12px 12px;
}
.invig-table {
  margin-bottom: 24px;
}
.suspect-chips { display: flex; flex-wrap: wrap; gap: 8px; }
.suspect-chips:nth-child(n+2) {
  margin-top: 10px;
}
.chip { background: #F2F3F5; color: #86909C; font-size: 12px; padding: 2px 8px; border-radius: 4px; }
.chip.chip-title {
  background: #E8F7E8;
  font-weight: bold;
}
.invig-pagination-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.table-empty-warp { padding: 24px; background: #F7F6F5; border-radius: 0 0 12px 12px; }

</style>
